/** A random DOM id such as "select-k3j9x0a1" */
export const uid = (prefix = ''): string =>
  prefix + '-' + Math.random()
    .toString(36)
    .slice(2, 10)
